module.exports = __webpack_public_path__ + "files/d43740a8da63b25894b8f25c777816c5.svg";